/* CP — visionneuse plein écran des photos produit */
(function(){
  var main=document.querySelector('.pmain'); if(!main) return;
  var mainImg=main.querySelector('img'); if(!mainImg) return;

  var css=''
   +'.pmain{cursor:zoom-in}'
   +'.cpz{position:fixed;inset:0;z-index:9999;display:none;background:rgba(11,13,15,.92);backdrop-filter:blur(6px)}'
   +'.cpz.on{display:block;animation:cpzIn .22s ease both}'
   +'@keyframes cpzIn{from{opacity:0}to{opacity:1}}'
   +'.cpz-fig{position:absolute;inset:56px 64px 72px;display:grid;place-items:center}'
   +'.cpz-fig img{max-width:100%;max-height:100%;object-fit:contain;border-radius:10px;background:#fff;'
   +'box-shadow:0 30px 80px rgba(0,0,0,.45);animation:cpzZ .26s cubic-bezier(.22,1,.36,1) both}'
   +'@keyframes cpzZ{from{opacity:0;transform:scale(.97)}to{opacity:1;transform:none}}'
   +'.cpz-b{position:absolute;border:0;background:rgba(255,255,255,.1);color:#fff;cursor:pointer;'
   +'display:grid;place-items:center;border-radius:50%;transition:background .18s,transform .18s;backdrop-filter:blur(4px)}'
   +'.cpz-b:hover{background:rgba(255,255,255,.22);transform:scale(1.06)}'
   +'.cpz-b svg{width:20px;height:20px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
   +'.cpz-x{top:16px;right:18px;width:44px;height:44px}'
   +'.cpz-p,.cpz-n{top:50%;margin-top:-24px;width:48px;height:48px}'
   +'.cpz-p{left:14px}.cpz-n{right:14px}'
   +'.cpz-c{position:absolute;left:0;right:0;bottom:24px;text-align:center;color:rgba(255,255,255,.75);'
   +'font-family:Archivo,system-ui,sans-serif;font-size:12px;font-weight:700;letter-spacing:.14em}'
   +'.cpz-t{position:absolute;left:0;right:0;top:22px;text-align:center;color:#fff;padding:0 70px;'
   +'font-family:Archivo,system-ui,sans-serif;font-size:12.5px;font-weight:800;letter-spacing:.1em;'
   +'text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
   +'@media(max-width:700px){.cpz-fig{inset:64px 12px 66px}.cpz-p,.cpz-n{width:40px;height:40px;margin-top:-20px}'
   +'.cpz-p{left:6px}.cpz-n{right:6px}.cpz-t{font-size:11px;padding:0 60px}}'
   +'body.cpz-lock{overflow:hidden}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

  var thumbs=[].slice.call(document.querySelectorAll('.pt[data-src]'));
  var srcs=thumbs.length ? thumbs.map(function(t){ return t.getAttribute('data-src'); })
                         : [mainImg.getAttribute('src')];
  var title=(document.querySelector('.ptit')||{}).textContent||'';
  var i=0;

  var d=document.createElement('div');
  d.className='cpz';
  d.setAttribute('role','dialog');
  d.setAttribute('aria-label','Photos du produit');
  d.innerHTML=''
   +'<div class="cpz-t"></div>'
   +'<div class="cpz-fig"><img alt=""></div>'
   +'<button type="button" class="cpz-b cpz-x" aria-label="Fermer"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
   +'<button type="button" class="cpz-b cpz-p" aria-label="Photo précédente"><svg viewBox="0 0 24 24"><path d="M15 5 8 12l7 7"/></svg></button>'
   +'<button type="button" class="cpz-b cpz-n" aria-label="Photo suivante"><svg viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg></button>'
   +'<div class="cpz-c"></div>';
  document.body.appendChild(d);

  var img=d.querySelector('.cpz-fig img'),
      cnt=d.querySelector('.cpz-c'),
      ttl=d.querySelector('.cpz-t'),
      bp=d.querySelector('.cpz-p'),
      bn=d.querySelector('.cpz-n');

  if(srcs.length<2){ bp.style.display='none'; bn.style.display='none'; }

  function big(u){ return u.replace(/([?&])width=\d+/, '$1width=1600'); }

  function show(k){
    i=(k+srcs.length)%srcs.length;
    img.src=big(srcs[i]);
    img.style.animation='none'; void img.offsetWidth; img.style.animation='';
    cnt.textContent = srcs.length>1 ? (i+1)+' / '+srcs.length : '';
    ttl.textContent = title;
    // précharge la suivante
    if(srcs.length>1){ var p=new Image(); p.src=big(srcs[(i+1)%srcs.length]); }
  }

  function open(){
    var cur=mainImg.getAttribute('src');
    var k=srcs.indexOf(cur);
    if(k<0){ k=0; for(var j=0;j<srcs.length;j++){ if(srcs[j].split('?')[0]===cur.split('?')[0]){ k=j; break; } } }
    show(k);
    d.classList.add('on');
    document.body.classList.add('cpz-lock');
  }
  function close(){ d.classList.remove('on'); document.body.classList.remove('cpz-lock'); }

  main.addEventListener('click', function(e){ e.preventDefault(); open(); });
  d.querySelector('.cpz-x').addEventListener('click', close);
  bp.addEventListener('click', function(e){ e.stopPropagation(); show(i-1); });
  bn.addEventListener('click', function(e){ e.stopPropagation(); show(i+1); });
  d.addEventListener('click', function(e){ if(e.target===d || e.target.className==='cpz-fig') close(); });
  document.addEventListener('keydown', function(e){
    if(!d.classList.contains('on')) return;
    if(e.key==='Escape') close();
    else if(e.key==='ArrowLeft') show(i-1);
    else if(e.key==='ArrowRight') show(i+1);
  });

  var x0=null;
  d.addEventListener('touchstart', function(e){ x0=e.touches[0].clientX; }, {passive:true});
  d.addEventListener('touchend', function(e){
    if(x0===null) return;
    var dx=e.changedTouches[0].clientX-x0; x0=null;
    if(Math.abs(dx)>45) show(dx<0 ? i+1 : i-1);
  }, {passive:true});
})();
